import React from "react";

function AssignUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#f9f7f7"
        fillRule="evenodd"
        d="M240.83 312.779v-55.31c0-29.405-19.05-35.444-43.352-50.03H43.352C19.05 222.026 0 228.064 0 257.47v55.31c0 6.797 3.122 5.951 8.315 5.951h224.2c5.193-.001 8.315.845 8.315-5.952z"
        clipRule="evenodd"
        data-original="#f9f7f7"
      ></path>
      <path
        fill="#838383"
        d="M216.936 454.795h-88.809v-53.207l4.897 4.897a7.702 7.702 0 005.464 2.263 7.703 7.703 0 005.462-2.261 7.722 7.722 0 00.002-10.923l-18.087-18.087-.008-.008a4.164 4.164 0 00-.307-.279 7.69 7.69 0 00-10.321.021 4.151 4.151 0 00-.291.264l-.006.005-18.059 18.087a7.722 7.722 0 005.469 13.18c1.98 0 3.96-.756 5.469-2.267l4.864-4.871v60.909a7.724 7.724 0 007.726 7.723h96.536a7.725 7.725 0 007.726-7.723 7.726 7.726 0 00-7.727-7.723zm195.238-324.551a7.73 7.73 0 00-10.927.002l-4.897 4.897v-60.93a7.724 7.724 0 00-7.726-7.723h-96.507a7.725 7.725 0 100 15.447h88.781v53.207L376 130.245a7.73 7.73 0 00-10.927-.002 7.722 7.722 0 00-.002 10.923l18.088 18.086a7.706 7.706 0 005.464 2.263 7.702 7.702 0 005.464-2.263l18.088-18.086a7.72 7.72 0 00-.001-10.922z"
        data-original="#838383"
      ></path>
      <path
        fill="#7bacdf"
        fillRule="evenodd"
        d="M154.504 292.505l-19.751-42.795-14.353-8.11-14.412 8.11-19.721 42.795c-.175.408-.321.438-.058.788l14.966 25.438h38.421l14.937-25.438c.292-.35.146-.38-.029-.788z"
        clipRule="evenodd"
        data-original="#7bacdf"
      ></path>
      <path
        fill="#3987d0"
        fillRule="evenodd"
        d="M134.754 249.71l6.126-24.067 3.151-11.902-23.631-9.802-11.115 5.193-12.282 5.717 2.859 10.852 6.126 24.009h14.383z"
        clipRule="evenodd"
        data-original="#3987d0"
      ></path>
      <path
        fill="#cecece"
        fillRule="evenodd"
        d="M99.862 225.701l20.538-21.762-14.12-13.652-27.686-3.997-35.242 21.15 36.759 23.775c6.797 3.997 8.373 7.701 13.478 1.138zm60.856 5.514l36.759-23.775-35.242-21.15-21.355 1.4-20.48 16.249 20.48 21.704 6.36 6.71c5.106 6.563 6.652 2.858 13.478-1.138z"
        clipRule="evenodd"
        data-original="#cecece"
      ></path>
      <path
        fill="#ffe5c1"
        fillRule="evenodd"
        d="M162.235 186.29c14.879-12.369 26.023-29.464 29.699-45.566.846-3.705 1.313-7.381 1.313-10.91V81.505h-13.391c-28.357 0-34.279-34.948-68.938-34.948H94.056c-26.548 0-6.331 40.257-36.876 40.257h-9.598v42.999c0 3.53.467 7.205 1.313 10.91 3.647 16.103 14.82 33.198 29.699 45.566 7.148 5.951 15.141 10.823 23.572 13.944 6.622 2.48 12.428 3.705 18.234 3.705 5.835 0 11.611-1.225 18.263-3.705 8.431-3.12 16.425-7.992 23.572-13.943z"
        clipRule="evenodd"
        data-original="#ffe5c1"
      ></path>
      <path
        fill="#838383"
        fillRule="evenodd"
        d="M193.247 67.502c0-34.044-34.95-57.206-67.275-60.502h-15.345C98.199 8.371 87.2 13.301 80.199 22.374c-35.184 3.121-32.616 49.942-32.616 56.097v28.938h9.598c30.545 0 10.328-40.257 36.876-40.257h16.862c34.658 0 40.552 34.919 68.938 34.919h13.391V67.502z"
        clipRule="evenodd"
        data-original="#838383"
      ></path>
      <path
        fill="#595959"
        fillRule="evenodd"
        d="M193.247 81.505V67.502c0-34.044-34.95-57.206-67.275-60.502h-15.258c31.508 4.288 64.445 27.101 64.445 60.152v34.597c1.488.204 3.063.321 4.697.321h13.391V86.814z"
        clipRule="evenodd"
        data-original="#595959"
      ></path>
      <path
        fill="#fed1a3"
        fillRule="evenodd"
        d="M193.247 129.813v-27.742h-13.391c-1.634 0-3.209-.117-4.697-.321v27.684c0 3.53-.438 7.205-1.284 10.91-3.676 16.103-14.849 33.168-29.699 45.566-.7.583-1.43 1.138-2.13 1.721-2.713 2.1-5.514 4.084-8.431 5.834-4.172 2.567-8.548 4.726-13.041 6.389a71.768 71.768 0 01-3.238 1.138c-2.363.758-4.639 1.371-6.885 1.779 3.413.788 6.681 1.167 9.948 1.167 5.835 0 11.611-1.225 18.263-3.705 8.431-3.121 16.425-7.993 23.572-13.944 14.879-12.369 26.023-29.464 29.699-45.566.847-3.704 1.314-7.38 1.314-10.91z"
        clipRule="evenodd"
        data-original="#fed1a3"
      ></path>
      <path
        fill="#fed1a3"
        fillRule="evenodd"
        d="M175.159 101.75c-24.448-3.559-31.566-34.598-64.241-34.598H94.056c-9.802 0-13.245 5.484-15.2 12.427H98.17c32.675 0 39.793 31.01 64.241 34.598 13.507-.175 12.749-1.75 12.749 15.257 0 3.53-.438 7.205-1.284 10.91-3.676 16.103-14.849 33.168-29.699 45.566-.7.583-1.43 1.138-2.13 1.721-2.713 2.1-5.514 4.084-8.431 5.834-4.172 2.567-8.548 4.726-13.041 6.389a71.768 71.768 0 01-3.238 1.138c-2.363.758-4.639 1.371-6.885 1.779 3.413.788 6.681 1.167 9.948 1.167 5.835 0 11.611-1.225 18.263-3.705 8.431-3.121 16.425-7.993 23.572-13.944 14.879-12.369 26.023-29.464 29.699-45.566.846-3.705 1.313-7.381 1.313-10.91v-27.742h-13.391c-1.633 0-3.209-.117-4.697-.321z"
        clipRule="evenodd"
        data-original="#fed1a3"
      ></path>
      <path
        fill="#b5adb6"
        fillRule="evenodd"
        d="M103.742 221.588l16.658-17.649c-3.267 0-6.535-.379-9.948-1.167-2.655-.613-5.368-1.459-8.285-2.538-8.431-3.121-16.425-7.993-23.572-13.944l-16.921 10.152a121.883 121.883 0 006.156 5.513c8.986 7.468 19.05 13.594 29.67 17.561.263.088.554.204.817.292 1.866.672 3.675 1.284 5.425 1.78zm39.589-2.071c10.619-3.967 20.655-10.093 29.641-17.561 2.13-1.75 4.201-3.617 6.185-5.513l-16.921-10.152c-7.148 5.951-15.141 10.823-23.572 13.944-6.652 2.48-12.428 3.705-18.263 3.705l16.687 17.649a81.019 81.019 0 005.339-1.75c.291-.118.612-.235.904-.322z"
        clipRule="evenodd"
        data-original="#b5adb6"
      ></path>
      <path
        fill="#0067b4"
        fillRule="evenodd"
        d="M137.088 221.588L120.4 203.939l-8.84 9.364 9.452 12.515 2.917 3.676c.904 1.109.671 1.284.321 2.684l-2.83 11.027-1.021 6.505h14.354l6.127-24.067z"
        clipRule="evenodd"
        data-original="#0067b4"
      ></path>
      <path
        fill="#3987d0"
        fillRule="evenodd"
        d="M154.504 292.505l-19.751-42.795H120.4l14.937 42.795c.175.408.292.438.029.788L120.4 318.73h19.196l14.937-25.438c.292-.349.146-.379-.029-.787z"
        clipRule="evenodd"
        data-original="#3987d0"
      ></path>
      <path
        fill="#e2e2e2"
        fillRule="evenodd"
        d="M240.83 257.47c0-29.405-19.05-35.444-43.352-50.03l-22.639 14.644c21.005 12.019 36.613 19.487 36.613 46.092v50.555h21.064c5.193 0 8.315.846 8.315-5.951v-55.31z"
        clipRule="evenodd"
        data-original="#e2e2e2"
      ></path>
      <path
        fill="#7bacdf"
        fillRule="evenodd"
        d="M512 499.013v-55.31c0-29.376-19.05-35.444-43.352-50.03H314.493c-24.302 14.586-43.352 20.654-43.352 50.03v55.31c0 6.826 3.122 5.951 8.344 5.951h224.172c5.221 0 8.343.875 8.343-5.951zm-134.841-63.07"
        clipRule="evenodd"
        data-original="#7bacdf"
      ></path>
      <path
        fill="#fe9737"
        fillRule="evenodd"
        d="M425.646 478.738l-19.721-42.795-14.353-8.11-14.412 8.11-19.751 42.795c-.175.408-.321.438-.058.817l14.966 25.409h38.422l14.966-25.409c.261-.379.116-.409-.059-.817z"
        clipRule="evenodd"
        data-original="#fe9737"
      ></path>
      <path
        fill="#fe7600"
        fillRule="evenodd"
        d="M405.924 435.943l6.127-24.067 3.15-11.902-23.63-9.772-11.116 5.163-12.282 5.718 2.859 10.881 6.127 23.979h14.382z"
        clipRule="evenodd"
        data-original="#fe7600"
      ></path>
      <path
        fill="#0078c8"
        fillRule="evenodd"
        d="M371.032 411.964l20.538-21.762-14.12-13.652-27.715-4.026-35.242 21.15 36.759 23.804c6.827 3.967 8.373 7.672 13.507 1.109zm60.857 5.513l36.759-23.804-35.242-21.15-21.355 1.429-20.48 16.249 20.48 21.675 6.331 6.71c5.134 6.563 6.68 2.859 13.507-1.109z"
        clipRule="evenodd"
        data-original="#0078c8"
      ></path>
      <path
        fill="#ffe5c1"
        fillRule="evenodd"
        d="M433.406 372.523c14.849-12.369 26.023-29.434 29.699-45.537.846-3.734 1.284-7.38 1.284-10.939v-48.308h-13.391c-28.357 0-34.279-34.919-68.908-34.919h-16.892c-26.519 0-6.331 40.257-36.846 40.257h-9.598v42.97c0 3.559.438 7.205 1.284 10.939 3.676 16.103 14.849 33.168 29.699 45.537 7.148 5.951 15.17 10.823 23.602 13.973 6.622 2.48 12.428 3.705 18.234 3.705s11.611-1.225 18.234-3.705c8.428-3.15 16.451-8.022 23.599-13.973z"
        clipRule="evenodd"
        data-original="#ffe5c1"
      ></path>
      <path
        fill="#838383"
        fillRule="evenodd"
        d="M464.388 253.736c0-34.044-34.921-57.206-67.246-60.502h-15.345c-12.428 1.371-23.427 6.301-30.457 15.403-35.184 3.092-32.587 49.913-32.587 56.097v28.909h9.598c30.516 0 10.327-40.257 36.846-40.257h16.892c34.658 0 40.552 34.948 68.908 34.948h13.391v-10.589z"
        clipRule="evenodd"
        data-original="#838383"
      ></path>
      <path
        fill="#595959"
        fillRule="evenodd"
        d="M464.388 267.738v-14.002c0-34.044-34.921-57.206-67.246-60.502h-15.287c31.508 4.317 64.474 27.101 64.474 60.182v34.567c1.488.233 3.034.35 4.668.35h13.391v-15.257z"
        clipRule="evenodd"
        data-original="#595959"
      ></path>
      <path
        fill="#fed1a3"
        fillRule="evenodd"
        d="M464.388 316.047v-27.713h-13.391c-1.634 0-3.18-.117-4.668-.35v27.684c0 3.559-.438 7.205-1.284 10.939-3.676 16.103-14.849 33.168-29.728 45.537-.7.583-1.4 1.167-2.13 1.721a86.743 86.743 0 01-8.402 5.864c-4.201 2.538-8.548 4.697-13.041 6.389a61.787 61.787 0 01-3.238 1.109 56.067 56.067 0 01-6.885 1.809c3.413.758 6.681 1.167 9.948 1.167 5.806 0 11.611-1.225 18.234-3.705 8.431-3.151 16.454-8.022 23.602-13.973 14.849-12.369 26.023-29.434 29.699-45.537.847-3.736 1.284-7.382 1.284-10.941z"
        clipRule="evenodd"
        data-original="#fed1a3"
      ></path>
      <path
        fill="#fed1a3"
        fillRule="evenodd"
        d="M446.33 287.983c-24.448-3.559-31.595-34.598-64.241-34.598h-16.892c-9.802 0-13.216 5.513-15.17 12.427h19.313c32.645 0 39.764 31.039 64.241 34.598 12.982 0 12.749-1.313 12.749 8.81v6.447c0 3.559-.438 7.205-1.284 10.939-3.676 16.103-14.849 33.168-29.728 45.537-.7.583-1.4 1.167-2.13 1.721a86.743 86.743 0 01-8.402 5.864c-4.201 2.538-8.548 4.697-13.041 6.389a61.787 61.787 0 01-3.238 1.109 56.067 56.067 0 01-6.885 1.809c3.413.758 6.681 1.167 9.948 1.167 5.806 0 11.611-1.225 18.234-3.705 8.431-3.151 16.454-8.022 23.602-13.973 14.849-12.369 26.023-29.434 29.699-45.537.846-3.734 1.284-7.38 1.284-10.939v-27.713h-13.391a30.177 30.177 0 01-4.668-.352z"
        clipRule="evenodd"
        data-original="#fed1a3"
      ></path>
      <path
        fill="#0067b4"
        fillRule="evenodd"
        d="M374.912 407.85l16.658-17.649c-3.267 0-6.535-.408-9.948-1.167-2.655-.613-5.397-1.459-8.285-2.538-8.431-3.151-16.454-8.022-23.602-13.973l-16.921 10.152a123.609 123.609 0 006.185 5.543c8.986 7.468 19.05 13.594 29.641 17.532.292.117.554.204.846.292 1.838.7 3.647 1.283 5.426 1.808zm39.589-2.1c10.59-3.938 20.655-10.064 29.641-17.532a122.627 122.627 0 006.185-5.543l-16.921-10.152c-7.148 5.951-15.17 10.823-23.602 13.973-6.622 2.48-12.428 3.705-18.234 3.705l16.658 17.649a126.54 126.54 0 005.368-1.75c.293-.117.584-.233.905-.35z"
        clipRule="evenodd"
        data-original="#0067b4"
      ></path>
      <path
        fill="#e6581f"
        fillRule="evenodd"
        d="M408.229 407.85l-16.658-17.649-8.84 9.364 9.452 12.486 2.917 3.705c.875 1.109.671 1.284.321 2.655l-2.83 11.056-1.021 6.476h14.353l6.126-24.067z"
        clipRule="evenodd"
        data-original="#e6581f"
      ></path>
      <path
        fill="#f36b37"
        fillRule="evenodd"
        d="M425.646 478.738l-19.721-42.795h-14.353l14.908 42.795c.175.408.321.438.058.817l-14.966 25.409h19.167l14.966-25.409c.261-.379.116-.409-.059-.817z"
        clipRule="evenodd"
        data-original="#f36b37"
      ></path>
      <path
        fill="#3987d0"
        fillRule="evenodd"
        d="M512 443.703c0-29.376-19.05-35.444-43.352-50.03l-22.639 14.673c20.976 11.99 36.613 19.458 36.613 46.092v50.526h21.035c5.222 0 8.344.875 8.344-5.951v-55.31z"
        clipRule="evenodd"
        data-original="#3987d0"
      ></path>
    </svg>
  );
}

export default AssignUser;